// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iL7o","content":"styles_content__1VZI9"};